import React from "react"
import { Alert, Box, Button, CircularProgress, Grid, TextField, Typography } from "@mui/material"
import {
  formatDateForInput,
  getAccessStatusCode,
  isAccessGrantedAndActive,
} from "../../../utils/adminAccessUserHelpers"
import { traducNameTemporal } from "../../../utils/traducTypes"
import styled from "@emotion/styled"

const InfoRow = ({ label, value }) => {
  return (
    <Grid container spacing={1} sx={{ mb: 1 }}>
      <Grid item xs={12} md={5}>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12} md={7}>
        <Typography variant="body2">{value || "-"}</Typography>
      </Grid>
    </Grid>
  )
}

const InputButton = styled(Button)(() => ({
  background: "#1C846F",
  "&:hover": {
    background: "#0CABA8",
  },
  borderRadius: "5rem",
  color: "#fff",
}))
export const AdminAccessOrganizationInfoPanel = ({
  organization,
  orgAccess,
  applicationInstanceId,
  organizationUsers,
  hasOrganization, successMessage, orgFinishDate, onOrgFinishDateChange, enablingOrganizationAccess, onEnableBaseAccess,
  validatingOrganization, loadingOrgContext, error,
  applicationName,
}) => {
  const isSearching = validatingOrganization || loadingOrgContext

  const isBusy = isSearching || enablingOrganizationAccess
  const showActionError = hasOrganization && Boolean(error)

  if (!organization) {
    return null
  }

  const hasOrgBaseAccess = isAccessGrantedAndActive(orgAccess)

  return (
    <div style={{ width: '80%', paddingBottom: 20 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Estado actual del acceso de la organización a la aplicación
      </Typography>

      {hasOrgBaseAccess ? (
        <Alert severity="success" sx={{ mb: 2 }}>
          La organización tiene acceso base activo a la aplicación.
        </Alert>
      ) : (
        <Alert severity="warning" sx={{ mb: 2 }}>
          La organización existe, pero no tiene acceso base activo a la aplicación o debe
          regularizarse.
        </Alert>
      )}

      <InfoRow
        label="Razón social"
        value={organization?.organizationLegalName}
      />
      <InfoRow label="Nombre" value={organization?.organizationName} />
      <InfoRow label="CUIT" value={organization?.organizationCuit} />
      <InfoRow label="Organization ID" value={organization?.organizationId} />
      <InfoRow
        label="Tipo organización"
        value={traducNameTemporal(organization?.organizationTypeCode) ||
          '- -'}
      />
      <InfoRow label="Activa" value={organization?.isActive ? "Sí" : "No"} />
      <InfoRow label="Application Instance ID" value={applicationInstanceId} />
      <InfoRow
        label="Estado acceso organización"
        value={getAccessStatusCode(orgAccess)}
      />
      <InfoRow
        label="Inicio acceso organización"
        value={formatDateForInput(
          orgAccess?.accessStartDate || orgAccess?.startDate,
        )}
      />
      <InfoRow
        label="Fin acceso organización"
        value={formatDateForInput(
          orgAccess?.accessFinishDate || orgAccess?.finishDate,
        )}
      />
      <InfoRow label="Cantidad usuarios" value={organizationUsers?.length} />
      {!hasOrganization ? null : (
        <>
          {showActionError ? <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert> : null}
          {successMessage ? <Alert severity="success" sx={{ mt: 2 }}>{successMessage}</Alert> : null}
          {!hasOrgBaseAccess ? (
            <>
              <Alert severity="info" sx={{ mt: 3 }}>
                La organización existe, pero no tiene habilitada la aplicación a nivel
                organización. Puedes dar el alta base desde aquí.
              </Alert>

              <Box sx={{ mt: 3 }}>
                <TextField
                  fullWidth
                  label="Fecha de expiración"
                  type="date"
                  value={orgFinishDate}
                  onChange={(event) => onOrgFinishDateChange(event.target.value)}
                  InputLabelProps={{ shrink: true }}
                  disabled={isBusy}
                />
              </Box>

              <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
                <InputButton onClick={onEnableBaseAccess}
                  disabled={isBusy || !orgFinishDate}>
                  {enablingOrganizationAccess ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "Confirmar alta organización / aplicación"
                  )}
                </InputButton>

              </Box>
            </>
          ) : (
            null
          )}
        </>)}
    </div>
  )
}

export default AdminAccessOrganizationInfoPanel
